import { channelInfoIdKey } from 'api/api.config';
import { useGetLanguagesQuery } from 'api/i18n/i18n';
import { getI18nLanguageRequest } from 'api/i18n/i18n.requests';
import { addi18nLanguage } from 'i18n/utils/addI18nLanguage';
import { useLayoutEffect } from 'react';
import { setCallbackUrl, setPartnershipData } from 'store/slices/utilityValues';
import { useAppDispatch } from 'store/store.hooks';
import { getChannelInfoId } from 'utils/functions/getChannelInfoId';

const useSaveSearchParamsValues = () => {
  const searchParams = new URLSearchParams(window.location.search);

  /*********************************************************
   *                   STORE HOOKS                         *
   ********************************************************/
  const dispatch = useAppDispatch();
  /*********************************************************
   *                    EFFECTS                            *
   ********************************************************/
  useLayoutEffect(() => {
    const callbackUrlFromSearchParams = searchParams.get('endcallbackurl');
    if (callbackUrlFromSearchParams)
      dispatch(
        setCallbackUrl({
          value: `${callbackUrlFromSearchParams}&${channelInfoIdKey}=${getChannelInfoId()}`,
        }),
      );

    const mppartner = searchParams.get('mppartner');
    if (mppartner)
      dispatch(
        setPartnershipData({
          partnershipData: {
            mppartner,
          },
        }),
      );
  }, []);
};

export const useInitializeAppServicesAndValues = () => {
  /*********************************************************
   *                    CONSTS                             *
   ********************************************************/
  const { language } = getI18nLanguageRequest();
  /*********************************************************
   *                   SERVICES HOOKS                      *
   ********************************************************/
  const { data: languagesQueryResult, isLoading: isLanguagesQueryLoading } =
    useGetLanguagesQuery(language);
  /*********************************************************
   *                    EFFECTS                            *
   ********************************************************/
  useLayoutEffect(() => {
    if (languagesQueryResult?.data)
      setTimeout(() => {
        addi18nLanguage(language, languagesQueryResult.data);
      }, 0);
  }, [languagesQueryResult]);

  useSaveSearchParamsValues();
  /*********************************************************
   *                    STATUSES                           *
   ********************************************************/
  const isLoading = isLanguagesQueryLoading;

  return { isLoading };
};
